<template>
  <head>
    <meta charset="utf-8"/>
    <title>Bill</title>
    <meta content="width=device-width, initial-scale=1.0" name="viewport">
    <meta content="Keep your finances and membership up to date" name="description"/>
    <meta content="" name="author"/>
    <!-- App favicon -->
    <link href="assets/images/favicon.svg" rel="shortcut icon">

    <!-- Bootstrap Css -->
    <link id="bootstrap-style" href="assets/css/bootstrap.min.css" rel="stylesheet" type="text/css"/>
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
    <!-- App Css-->
    <link id="app-style" href="assets/css/app.min.css" rel="stylesheet" type="text/css"/>
    <!-- custom Css-->
    <link id="app-style" href="assets/css/custom.css" rel="stylesheet" type="text/css"/>
  </head>

  <body data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <Navigation/>

    <!-- Start right Content here -->
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- Today's Active Stats -->
          <TodaysActiveStats />

          <!-- Performance Summary with Map and Transaction Cards -->
          <div class="row">
            <div class="col-xl-4 px-sm-30px">
              <CollectorsPerformanceCard />
            </div>
            <div class="col-xl-8 px-sm-30px">
              <TransactionCards />
            </div>
          </div>

          <!-- Revenue Collection Tables -->
          <RevenueCollectionTables />

        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              <span class="this-year">-</span> © County Biller
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block d-flex align-items-center">
                <span>Powered By </span>
                <img height="30" :src="county.poweredByLogo"/>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
  </body>
</template>

<script>
/* eslint-disable */
import Navigation from "@/components/Navigation.vue";
import TodaysActiveStats from "@/components/dashboard/sections/TodaysActiveStats.vue";
import CollectorsPerformanceCard from "@/components/dashboard/sections/CollectorsPerformanceCard.vue";
import TransactionCards from "@/components/dashboard/sections/TransactionCards.vue";
import RevenueCollectionTables from "@/components/dashboard/sections/RevenueCollectionTables.vue";
import { biller, execute } from "@/api";

export default {
  name: "Dashboard",
  components: {
    Navigation,
    TodaysActiveStats,
    CollectorsPerformanceCard,
    TransactionCards,
    RevenueCollectionTables
  },
  data() {
    return {
      county: {
        poweredByLogo: null
      }
    }
  },
  mounted() {
    this.getCountyData();
  },
  methods: {
    getCountyData() {
      const cachedCounty = localStorage.getItem("countyData");
      if (cachedCounty) {
        this.county = JSON.parse(cachedCounty);
      }
    }
  }
}
</script>